export const API_BASE_URI = 'https://dp-airgen.nta.co.jp/dp-airgen';

export const DP_SIGNUP_URI = 'https://mbr.nta.co.jp/ecsystem_portal/view/newmemberentry/memberRules4.html';

export const DP_USERID_RESET_URI = 'https://mbr.nta.co.jp/ecsystem_portal/view/useridreminder/userNameInput';

export const DP_PASSWORD_RESET_URI = 'https://mbr.nta.co.jp/ecsystem_portal/view/passwordreminder/mailAddressInput';

export const DP_AGREEMENT_URI = 'https://gttagree.nta.co.jp/';

export const RTOASTER_CODE = 'RTA-740c-1c996c2310d9';

export const ENROLLMENT_SRC = '【DPP memberRules4】';

export const ANA2_START_DATE = '20260519';